// import config from 'config';
import axios from 'axios';
import { handleResponse } from './http-utils';

export const refDeliveryModelService = {
    getByAccount,
    getById,
    add,
    update,
    deleteEntity
};

function getByAccount(accountId) {
    // return axios.get(`/areas/?accountId=${accountId}`).then(handleResponse);
    return axios.get(`/refDeliveryModels/`).then(handleResponse);
}

function getById(id) {
    return axios.get(`/refDeliveryModels/${id}`).then(handleResponse);
}

function add(refDeliveryModel) {
    return axios.post('/refDeliveryModels', refDeliveryModel).then(handleResponse);
}

function update(refDeliveryModel) {
    return axios.put(`/refDeliveryModels/${refDeliveryModel.refDeliveryModelId}`, refDeliveryModel).then(handleResponse);
}

function deleteEntity(refDeliveryModel) {
    return axios.delete(`/refDeliveryModels/${refDeliveryModel.refDeliveryModelId}`).then(handleResponse);
}
